export default __webpack_public_path__ + "static/media/facility-legend-icon-new.ae3806ea.svg";